type LatLng = { lat: number; lng: number };

const R = 6371;

function distanceKm(a: LatLng, b: LatLng) {
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
}

export function buildWaterIntelEnvironment(weatherData: any, anchor: LatLng | null) {
  if (!weatherData || !anchor) return null;
  const lat = Number(weatherData?.coords?.lat);
  const lng = Number(weatherData?.coords?.lon ?? weatherData?.coords?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  const sourceDistanceKm = distanceKm(anchor, { lat, lng });
  if (sourceDistanceKm > 35) return null;

  const current = weatherData?.current || {};
  const tides = weatherData?.tides || {};
  const marine = weatherData?.marine || {};

  return {
    sourceDistanceKm,
    weather: {
      temp: current?.temp,
      condition: current?.condition,
      wind: current?.wind,
      pressure: current?.pressure,
      clouds: current?.clouds,
      visibility: current?.visibility,
      precipitation: current?.precipitation,
    },
    light: {
      moonPhase: weatherData?.moonPhase ?? weatherData?.astronomy?.moonPhase ?? current?.moonPhase,
      sunrise: weatherData?.sunrise ?? weatherData?.astronomy?.sunrise ?? current?.sunrise,
      sunset: weatherData?.sunset ?? weatherData?.astronomy?.sunset ?? current?.sunset,
    },
    tides: {
      stationName: tides?.stationName,
      nextHigh: tides?.nextHigh ?? current?.nextHighTide,
      nextLow: tides?.nextLow ?? current?.nextLowTide,
    },
    marine: {
      waveHeight: marine?.waveHeight,
      waveDirection: marine?.waveDirection,
      wavePeriod: marine?.wavePeriod,
    },
    provider: weatherData?.provider ?? weatherData?.source,
    fetchedAt: weatherData?.fetchedAt,
  };
}
